import Vue from 'vue';
import App from './app.vue';
import ViewUI from 'view-design';
import { router } from './router/index';
import VueCropper from 'vue-cropper';
import clipboard from 'clipboard';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import './theme.less';
import Ajax from './lib/ajax';
import Util from './lib/util';
import SignalRAspNetCoreHelper from './lib/SignalRAspNetCoreHelper';
import store from './store/index';
import { appRouters, otherRouters } from './router/router';
import EwebEditor from './components/ewebeditors/index.js'
Vue.config.productionTip = false;

Vue.use(ViewUI);
Vue.use(VueCropper);
Vue.use(EwebEditor);
Vue.prototype.clipboard = clipboard;
Vue.prototype.$Message.config({
  top: 200,
  duration: 4
});




Vue.filter('comgw', function (value) {
  var str = value.split("\n");
  var costr = "";
  var arr = ["①", "②", "③", "④"]
  for (var i = 0; i < str.length; i++) {
    costr += arr[i] + str[i] + ";";
  }
  costr = costr.substring(0, costr.length - 1);
  return costr;
});

Vue.filter('momentdt', function (value) {
  var dateee = new Date(value).toJSON();
  var date = new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  return date
});

Vue.filter('getwatname', function (id, data) {
  for (var item of data) {
    if (item.id === id) return item.name;
  }
});
if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue('Abp.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);//5 * 365 * 86400000
}

Ajax.get('/AbpUserConfiguration/GetAll').then(data => {
  Util.abp = Util.extend(true, Util.abp, data.data.result);
  new Vue({
    render: h => h(App),
    router: router,
    store: store,
    data: {
      currentPageName: ''
    },
    async mounted() {
      this.currentPageName = this.$route.name as string;
      await this.$store.dispatch({
        type: 'session/init'
      })
      if (!!this.$store.state.session.user && this.$store.state.session.application.features['SignalR']) {
        if (this.$store.state.session.application.features['SignalR.AspNetCore']) {
          SignalRAspNetCoreHelper.initSignalR();
        }
      }
      this.$store.commit('app/initCachepage');
      this.$store.commit('app/updateMenulist');
    },
    created() {
      let tagsList: Array<any> = [];
      appRouters.map((item) => {
        if (item.children.length <= 1) {
          tagsList.push(item.children[0]);
        } else {
          tagsList.push(...item.children);
        }
      });
      this.$store.commit('app/setTagsList', tagsList);
    }
  }).$mount('#app')
})
  .catch(retult => {
    new Vue({
      render: h => h(App),
      router: router,
      store: store,
      data: {
        currentPageName: ''
      }
    }).$mount('#app')
  });
